import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'store';
import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import Typography from '@material-ui/core/Typography';
import {
  Button,
  Grid,
  Menu,
  MenuItem,
  Popper,
  Tooltip,
} from '@material-ui/core';
import { MoreVert } from '@material-ui/icons';
import StatusBadge from 'components/Badges';
import './index.scss';
import {
  ContratoStatus,
  statusMapping,
  tipoContratoMapping,
  URL_ENTE_DESCENTRALIZADO,
  VersaoContratoEnum,
} from 'models/contratos';
import { useLocation, useParams } from 'react-router-dom';
import {
} from '../../../../models/contratos';
import AccordionArrowOpenClose from 'assets/icons/AccordionArrowOpenClose';
import ModalFiles from 'pages/Contratos/components/ModalFiles';
import {
  CreateRouteParams,
  EditRouteParams,
} from 'pages/Contratos/Fluxos/FluxoDescentralizados/__types';
import ModalAditivoAssessor from 'pages/Contratos/Fluxos/FluxoDescentralizados/Assessor/Documentos/ModalAditivo';
import AccordionAlert from 'assets/icons/AccordionAlert';
import ModalDistratoAssessor from 'pages/Contratos/Fluxos/FluxoDescentralizados/Assessor/Documentos/ModalDistrato';
import { Modal } from 'components/Modal';
import { useAccordionDetalhe } from './Hooks/useAccordionLista';
import { useAccordionMenuItem } from './Hooks/useAccordionMenuItem';
import ModalAditivoEntePublico from 'pages/Contratos/Fluxos/FluxoDescentralizados/EntePublico/Documentos/ModalAditivo';
import ModalDistratoEntePublico from 'pages/Contratos/Fluxos/FluxoDescentralizados/EntePublico/Documentos/ModalDistrato';
import ModalAditivoEntePrivado from 'pages/Contratos/Fluxos/FluxoDescentralizados/EntePrivado/Documento/ModalAditivo'
import ModalDistratoEntePrivado from 'pages/Contratos/Fluxos/FluxoDescentralizados/EntePrivado/Documento/ModalDistrato'
import { clearUploadedFile, clearUploadSelectedOption } from 'store/modules/AllContratos/AllContratosActions';

type InfoContratoAccordionProps = {
  id: number | null;
  ativo: boolean;
  codigo: string;
  flgStatus: number;
  idDocAssinado: number | null;
  idDocExtrato: number | null;
  idDocPlanoTrabalho: number | null;
  dataAlteracao: string | undefined;
  versaoContrato: number;
  incluiPlanoTrabalho: boolean;
};

function ControlledAccordions({
  id,
  ativo,
  codigo,
  flgStatus,
  idDocAssinado,
  idDocPlanoTrabalho,
  idDocExtrato,
  dataAlteracao,
  versaoContrato,
  incluiPlanoTrabalho
}: InfoContratoAccordionProps) {
  const [expanded, setExpanded] = React.useState<string | false>(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [, setCurrentKey] = useState<string | null>(null);
  const [isModalFileOpen, setIsModalFilesOpen] = useState(false);
  const {
    handleContratoEdit,
    renderizaDetalhesContrato
  } = useAccordionDetalhe(setExpanded, id, versaoContrato, flgStatus, incluiPlanoTrabalho, dataAlteracao);
  const {
    inibeBotaoExcluir,
    excluiDocumento,
    contractDisabled,
    contractEnabled
  } = useAccordionMenuItem(id, versaoContrato);
  const languageValues = useSelector(
    (states: RootState) => states.languages.languageValues
  );
  const location = useLocation();
  const dispatch = useDispatch();
  const params = useParams<CreateRouteParams & EditRouteParams>();

  const fluxoAssessor = location.pathname.includes(URL_ENTE_DESCENTRALIZADO.ASSESSOR);
  const fluxoEntePublico = location.pathname.includes(URL_ENTE_DESCENTRALIZADO.ENTE_PUBLICO);
  const fluxoEntePrivado = location.pathname.includes(URL_ENTE_DESCENTRALIZADO.ENTE_PRIVADO);

  useEffect(() => {
    const notificacaoAditivoId = params.param;
    if (notificacaoAditivoId) {
      setExpanded(`panel-${notificacaoAditivoId}`);
    }
  }, [params.param]);

  const handleChange = useCallback(
    (panel: string) => (event: React.ChangeEvent<unknown>, isExpanded: boolean) => {
      setExpanded(isExpanded ? panel : false);
    },
    []
  );

  const handleMenuClick = useCallback((event: React.MouseEvent<HTMLElement>) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
    setIsMenuOpen(true);
  }, []);

  const handleCloseMenu = useCallback(() => {
    setAnchorEl(null);
    setIsMenuOpen(false);
    setCurrentKey(null);
  }, []);

  const openModalFiles = () => {
    setIsModalFilesOpen(true);
    handleCloseMenu();
  };

  const closeModalFiles = () => {
    setIsModalFilesOpen(false);
  };

  const renderTooltip = (title: string) => (
    <Tooltip
      title={title}
      PopperComponent={Popper}
    >
      <span className={'accordionItemData__column-icon color-actions'}>
        <AccordionAlert color={'#E6A500'} />
      </span>
    </Tooltip>
  );

  const verificaAusenciaDocumento = () => {
    switch (true) {
      case (fluxoAssessor || fluxoEntePrivado) && idDocAssinado === null:
        return renderTooltip(languageValues.documentoAssinadoFalta);
      case fluxoEntePublico && idDocAssinado === null && idDocAssinado === null:
        return renderTooltip(languageValues.documentoExtratoEAssinadoFalta);
      case fluxoEntePublico && idDocAssinado === null:
        return renderTooltip(languageValues.documentoAssinadoFalta);
      case fluxoEntePublico && idDocExtrato === null:
        return renderTooltip(languageValues.documentoExtratoFalta);
      default:
        return null;
    }
  };

  const getMenuItemLabel = (isAtivo: boolean, contratoVersao: number) => {
    switch (contratoVersao) {
      case VersaoContratoEnum.CONTRATO:
        return isAtivo
          ? languageValues.desativarContrato
          : languageValues.ativarContrato;

      case VersaoContratoEnum.ADITIVO:
        return isAtivo
          ? languageValues.desativarAditivo
          : languageValues.ativarAditivo;

      case VersaoContratoEnum.DISTRATO:
        return isAtivo
          ? languageValues.desativarDistrato
          : languageValues.ativarDistrato;

      default:
        return languageValues.tipoContratoNaoEncontrado;
    }
  };

  const getStatusBadge = (versaoContratoBadge: number) => {
    switch (versaoContratoBadge) {
      case VersaoContratoEnum.CONTRATO:
        return tipoContratoMapping[VersaoContratoEnum.CONTRATO];
      case VersaoContratoEnum.ADITIVO:
        return tipoContratoMapping[VersaoContratoEnum.ADITIVO];
      case VersaoContratoEnum.DISTRATO:
        return tipoContratoMapping[VersaoContratoEnum.DISTRATO];
      default:
        return undefined;
    }
  };

  const labelBotaoDocumentos = () => {
    switch (true) {
      case fluxoAssessor:
        return languageValues.documentoAssinado
      case fluxoEntePublico:
        return languageValues.documentos
      case fluxoEntePrivado:
        return languageValues.documentoAssinado
      default:
        return languageValues.naoDefinido
    }
  }

  const labelBotaoExcluir = () => {
    switch (true) {
      case fluxoAssessor:
        return languageValues.excluir
      case fluxoEntePublico:
        return languageValues.excluirDocumentos
      case fluxoEntePrivado:
        return languageValues.excluir
      default:
        return languageValues.naoDefinido
    }
  }

  return (
    <>
      <ModalFiles
        id={id}
        versaoContrato={versaoContrato}
        open={isModalFileOpen}
        close={() => closeModalFiles()}
        idDocAssinado={idDocAssinado}
        idDocPlanoTrabalho={idDocPlanoTrabalho}
        idDocExtrato={idDocExtrato}
        incluiPlanoTrabalho={incluiPlanoTrabalho}
      />

      <ModalAditivoAssessor />
      <ModalDistratoAssessor />

      <ModalAditivoEntePublico />
      <ModalDistratoEntePublico />

      <ModalAditivoEntePrivado />
      <ModalDistratoEntePrivado />

      <Modal
        open={isConfirmModalOpen}
        close={() => setIsConfirmModalOpen(false)}
        handleBack={() => {
          excluiDocumento();
          setIsConfirmModalOpen(false);
        }}
        title={languageValues.confirmModalTitleAviso}
        content={languageValues.confirmModalTitleExcluirDocumento}
        cancelContent={languageValues.confirmModalBackButtonNao}
        confirmContent={languageValues.confirmModalConfirmButtonSim}
      />

      <div className='root-documents-accordion'>
        <Accordion
          className='Accordion'
          expanded={expanded === `panel-${id}`}
          onChange={handleChange(`panel-${id}`)}
        >
          <AccordionSummary
            className='accordionItemData'
            expandIcon={<AccordionArrowOpenClose style={{ fill: '#8C5F0F' }} />}
            aria-controls={`panel-${id}bh-content`}
            id={`panel-${id}bh-header`}
          >
            <Grid container spacing={1}>
              <Grid item xs={4} md={4} className='accordionItemData__grid-item'>
                <Typography
                  className={`accordionItemData__column-sub ${!ativo ? 'disabled' : ''
                    }`}
                  onClick={() => handleContratoEdit()}
                >
                  {codigo}
                </Typography>
              </Grid>
              <Grid item xs={3} md={3} className='accordionItemData__grid-item'>
                <Typography
                  className={`accordionItemData__column-sub ${!ativo ? 'disabled' : ''}`}
                >
                  <StatusBadge
                    versaoContrato={getStatusBadge(versaoContrato)}
                  />
                </Typography>
              </Grid>
              <Grid item xs={3} md={3} className='accordionItemData__grid-item'>
                {ativo ? (
                  <StatusBadge status={statusMapping[flgStatus ?? 0]} />
                ) : (
                  <StatusBadge className='accordionItemData__badge-desativado' status={statusMapping[ContratoStatus.DESATIVADO]} />
                )}
              </Grid>
              <Grid item xs={1} md={1} className='accordionItemData__grid-icon'>
                {verificaAusenciaDocumento()}
              </Grid>
              <Grid item xs={1} md={1} className='accordionItemData__grid-item'>
                <Typography className='accordionItemData__column-sub color-actions'>
                  <Button
                    className='accordionItemData__buttonMenu'
                    id='actions'
                    onClick={(e) => handleMenuClick(e)}
                    aria-label="MoreActions"
                  >
                    <MoreVert style={{ color: '#8C5F0F' }} />
                  </Button>
                </Typography>
              </Grid>
            </Grid>
          </AccordionSummary>

          <AccordionDetails className='accordionDetails'>
            {renderizaDetalhesContrato({ idDocAssinado, idDocPlanoTrabalho, idDocExtrato, incluiPlanoTrabalho })}
            <Menu
              anchorEl={anchorEl}
              open={isMenuOpen}
              onClose={handleCloseMenu}
              anchorOrigin={{ horizontal: 'right', vertical: 'top' }}
              transformOrigin={{ vertical: 'top', horizontal: 'right' }}
              keepMounted
            >
              <MenuItem onClick={() => {
                if (fluxoEntePublico) {
                  dispatch(clearUploadedFile());
                  dispatch(clearUploadSelectedOption());
                }
                openModalFiles();
                handleCloseMenu()
              }}
                disabled={!ativo}>
                {labelBotaoDocumentos()}
              </MenuItem>
              {flgStatus === ContratoStatus.EM_EDICAO ? (
                <MenuItem
                  onClick={() => {
                    if (ativo) {
                      contractDisabled();
                    } else {
                      contractEnabled();
                    }
                    handleCloseMenu();
                  }}
                >
                  {getMenuItemLabel(ativo, versaoContrato)}
                </MenuItem>
              ) : null}
              {inibeBotaoExcluir() && (
                <MenuItem
                  onClick={() => {
                    setIsConfirmModalOpen(true);
                    handleCloseMenu()
                  }}
                >
                  {labelBotaoExcluir()}
                </MenuItem>
              )}
            </Menu>
          </AccordionDetails>
        </Accordion>
      </div >
    </>
  );
}

export default React.memo(ControlledAccordions);

